export const loginFormModalTextContent = {
  ModalTitleText: "Login",
  btnText: "Login",
  currencies: [
    { currencyName: "EUR"},
    { currencyName: "USD"}
  ],
  language: [
    { languageName: "English", code: "EN"},
    { languageName: "Chinese", code: "CH"},
    { languageName: "Korean", code: "KR"},
  ]
};
